export type ObservationWithType = {
    type: {
        id: string;
        name: string;
    };
};

export type ObservationGroup<T extends ObservationWithType> = {
    id: string;
    name: string;
    observations: T[];
};

export function groupObservationsByType<T extends ObservationWithType>(observations: T[]): ObservationGroup<T>[] {
    const groups = new Map<string, ObservationGroup<T>>();

    for (const observation of observations) {
        const typeId = observation.type.id;
        const group = groups.get(typeId);
        if (group) {
            group.observations.push(observation);
        } else {
            groups.set(typeId, {
                id: typeId,
                name: observation.type.name,
                observations: [observation],
            });
        }
    }

    return [...groups.values()].sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: "base" }));
}
